import { formatDeviceTimestamp } from "../../../api/mocks/accountDevices.mock.js";
import { formatColumnLabel } from "../../Accounts/assetUtils.js";

export const DEVICE_FORM_EMPTY = {
  accountId: "",
  deviceId: "",
  deviceTypeId: "",
  simId: "",
  values: {},
};

export function deviceToForm(device) {
  if (!device) return { ...DEVICE_FORM_EMPTY, values: {} };
  return {
    accountId: device.accountId ?? "",
    deviceId: device.deviceId ?? "",
    deviceTypeId: device.deviceTypeId ?? "",
    simId: device.simId ?? "",
    values: { ...(device.values ?? {}) },
  };
}

export function deviceFormToPayload(form, deviceType, sim) {
  return {
    accountId: form.accountId?.trim() ?? "",
    deviceId: form.deviceId?.trim().toUpperCase() ?? "",
    deviceTypeId: form.deviceTypeId?.trim() ?? "",
    deviceType: deviceType?.name ?? "",
    simId: form.simId?.trim() ?? "",
    simType: sim?.simType ?? "",
    simNumber: sim?.iccid ?? "",
    values: form.values ?? {},
  };
}

export function validateDeviceStep(form, step, deviceType, isEdit) {
  const errors = {};
  if (step === 1) {
    if (!isEdit && !form.deviceId?.trim()) errors.deviceId = "Device ID is required";
    if (!form.deviceTypeId?.trim()) errors.deviceTypeId = "Device type is required";
    if (!form.simId?.trim()) errors.simId = "SIM is required";
    return errors;
  }

  const columns = deviceType?.columns ?? [];
  const valueErrors = {};
  columns.forEach((col) => {
    const raw = form.values?.[col.key];
    if (!String(raw ?? "").trim()) {
      valueErrors[col.key] = `${formatColumnLabel(col.key)} is required`;
      return;
    }
    if (col.type === "int" && !/^-?\d+$/.test(String(raw).trim())) {
      valueErrors[col.key] = "Enter a whole number";
    }
  });
  if (Object.keys(valueErrors).length) errors.values = valueErrors;
  return errors;
}

export function buildDeviceListSubtitle(device, deviceType) {
  const values = Object.values(device?.values ?? {}).filter(Boolean);
  if (values.length > 0) return values.slice(0, 2).join(" · ");
  return deviceType?.name ?? device?.deviceType ?? "Device";
}

export function buildDeviceDetailFields(device, accountName, deviceType, sim) {
  if (!device) return [];
  const fields = [
    { label: "Device type", value: deviceType?.name ?? device.deviceType ?? "—", icon: "model" },
    { label: "SIM type", value: sim?.simType ?? device.simType ?? "—", icon: "sim" },
    { label: "SIM ICCID", value: sim?.iccid ?? device.simNumber ?? "—", icon: "device" },
    { label: "Account", value: accountName, icon: "building" },
  ];
  (deviceType?.columns ?? []).forEach((col) => {
    fields.push({
      label: formatColumnLabel(col.key),
      value: device.values?.[col.key] ?? "—",
      icon: col.type === "int" ? "grid" : col.type === "file" ? "layers" : "model",
    });
  });
  return fields;
}

export function buildDeviceDetailRows(fields) {
  if (fields.length <= 3) return [fields];
  const rows = [];
  for (let i = 0; i < fields.length; i += 3) {
    rows.push(fields.slice(i, i + 3));
  }
  return rows;
}

export function buildDeviceSummaryFields(device) {
  if (!device) return [];
  return [
    { label: "Device ID", value: device.deviceId },
    { label: "Created at", value: formatDeviceTimestamp(device.createdAt) },
    { label: "Updated at", value: formatDeviceTimestamp(device.updatedAt) },
  ];
}
